import { Database } from '@vuex-orm/core';
import * as Models from "../models";

const database = new Database();


Object.entries(Models).forEach(([, value]) => {
    database.register(value);
});

export default database
